import { FETCH_PLAYING_REQUESTED } from "./actions";
import { PLAYING_LOADED } from "./actions";
import { PLAYING_ERROR } from "./actions";
import { LOAD_MORE } from "./actions";
import { LOAD_MORE_REQUESTED } from "./actions";

const defaultState = {
  moviesPlaying: [],
  loading: true,
  error: null,
  page: 1
};

export const playingReducer = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_PLAYING_REQUESTED:
      return {
        moviesPlaying: [],
        loading: true,
        error: null,
        page: state.page
      };

    case PLAYING_LOADED:
      return {
        moviesPlaying: action.payload,
        loading: false,
        error: null,
        page: state.page
      };

    case PLAYING_ERROR:
      return {
        moviesPlaying: [],
        loading: false,
        error: true,
        page: state.page
      };
    case LOAD_MORE_REQUESTED:
      return {
        moviesPlaying: state.moviesPlaying,
        loading: false,
        error: null,
        page: state.page + 1
      };
    case LOAD_MORE:
      return {
        moviesPlaying: [...state.moviesPlaying, ...action.payload],
        loading: false,
        error: null,
        page: state.page
      };

    default:
      return state;
  }
};
